import { useCallback, useState } from "react";
import { EnableTotpRepositoryImpl } from "../../infrastructure/repositories/EnableTotpRepositoryImpl";
import { SessionManager } from "../../infrastructure/session/SessionManager";
import { sendEmailOtp as sendEmailOtpUseCase } from "../useCases/sendEmailOtp";

export const useSendEmailOtp = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sendEmailOtp = useCallback(async (
    email: string,
    purpose: string,
    bearerTokenOverride?: string,
  ): Promise<number> => {
    setLoading(true);
    setError(null);
    try {
      const repo = new EnableTotpRepositoryImpl();
      const sessionPort = new SessionManager();
      return await sendEmailOtpUseCase(
        repo,
        sessionPort,
        email,
        purpose,
        bearerTokenOverride,
      );
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : String(err));
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { sendEmailOtp, loading, error };
};